import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { ArticleClickedData, GuideModuleWithType } from '@/features/editorial/types/editorial-types';

import { useGuideModules } from '@/features/editorial/composables/useGuideModules';


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarLayout',
  props: {
    moduleData: null,
    moduleIndex: null
  },
  emits: ["articleClicked", "authorClicked"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'articleClicked', data?: ArticleClickedData): void;
	(e: 'authorClicked', id: string | undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	moduleData: GuideModuleWithType;
	moduleIndex: number;
};

const { getBlockComponent } = useGuideModules();





const mainBlock = computed(() => props.moduleData.modules[0]);
const sideBlock = computed(() => props.moduleData.modules[1]);

function handleArticleClick(data?: ArticleClickedData) {
	emits('articleClicked', data);
}

function handleAuthorClick(id: string | undefined) {
	emits('authorClicked', id);
}

return { __sfc: true,getBlockComponent, props, emits, mainBlock, sideBlock, handleArticleClick, handleAuthorClick }
}

})